<template>
    <v-app>
      <Drawer current_item="menu_ext_package"></Drawer>
      
      <v-main class="ml-6 mr-6">
        <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
            >
                <v-card-title> {{ $t('ext_package_title') }}</v-card-title>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :items-per-page="10"
                    :items="items"
                >
                    <template v-slot:top >
                        <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <DlgExtPackage ref="dlgExtPackage" @onCloseDialog="onCloseDialog"></DlgExtPackage>
                        </v-toolbar>
                    </template>
                    <template  v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
      </v-main>
      <v-snackbar
            v-model="snackbar"
            timeout="2000"
     >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import config from '@/../config.js'
import DlgExtPackage from './DlgExtPackage'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'
import numeral from 'numeral'

export default {
  name: 'ExtPackage',
  computed: {
    headers() {
      return [
            {text: this.$t('ext_package_name'), value: 'ext_package_name', width: '40%'},
            {text: this.$t('ext_package_unit_price_label'), value: 'unit_price_display', width: '40%'},
            {text: 'Actions', value: 'action', sortable: false}
        ]
    }
  },
  components: {
      Drawer,
      DlgExtPackage
  },
  data: () => ({
      items: [],
      editedIndex: -1,
      snackbar: false,
      message: ''
  }),
  methods: {
      loadExtPackage() {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.ext_package.list_ext_package,
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.items = rs.data;
            if (this.items) {
                this.items.forEach(o => {
                    o.unit_price_display = numeral(o.unit_price).format('0,0.00');
                })
            }
        })
        .catch(error => {
            this.$store.commit('finishLoading',que)
            this.$router.push({name:'Error',params:error}) 
        });
      },
      editItem(item) {
          this.editedIndex = this.items.indexOf(item);
          this.$refs.dlgExtPackage.show(Object.assign({}, item));
      },
      deleteItem(item) {
        var que = this.$store.commit('addLoading')
        axios.get(
            config.api.url.manage.ext_package.delete_ext_package + item.ext_package_id,
            { headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.editedIndex = this.items.indexOf(item);
            this.items.splice(this.editedIndex, 1);
            this.editedIndex = -1;
        })
      },
      onCloseDialog(isSuccess) {
          if (isSuccess == true) {
              this.loadExtPackage();
              this.message = this.$t('save_success');
              this.snackbar = true;
          }
          
          this.editedIndex = -1;
      }
  },
  mounted() {
      this.loadExtPackage();
  }
}
</script>